import { render, staticRenderFns } from "./MarketTitle.vue?vue&type=template&id=e80a8232&scoped=true&"
import script from "./MarketTitle.vue?vue&type=script&lang=js&"
export * from "./MarketTitle.vue?vue&type=script&lang=js&"
import style0 from "./MarketTitle.vue?vue&type=style&index=0&id=e80a8232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80a8232",
  null
  
)

export default component.exports